import React, { useEffect, useRef } from 'react';
import ReactDOM from "react-dom";
import css from './Map.module.css';
import { isMapsLibLoaded } from './MapboxMap';

const mapMarker = () => {
  const el = document.createElement('div');
  el.style.cursor = 'pointer';
  el.innerHTML = `<svg width="7" height="20" viewBox="0 0 7 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.38649 0.375H4.61351V3.96478C4.61351 4.99951 4.91996 5.96052 5.52432 6.83953L5.52423 6.8396L5.52978 6.84725L5.84879 7.28707C6.36747 8.04305 6.625 8.88922 6.625 9.76722V19.625H0.375V9.76722C0.375 8.89132 0.631399 8.04338 1.15332 7.25003L1.47022 6.81312L1.47023 6.81312L1.47136 6.81154C2.08148 5.96113 2.38649 4.96271 2.38649 3.96478V0.375Z" fill="#78264F" stroke="#78264F" stroke-width="0.75"/>
  </svg>
  `
  return new window.mapboxgl.Marker({element: el});
};

const MboxMap = ({center, zoom, locations}) => {
  const mapContainer = useRef();

  useEffect(() => {
    if(typeof window !== 'undefined' && window.mapboxgl) {
      const map = new window.mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/streets-v10',
        center,
        zoom,
        scrollZoom: false,
        attributionControl: false
      });

      map.addControl(new window.mapboxgl.FullscreenControl(), 'top-left');
      map.addControl(new window.mapboxgl.NavigationControl({ showCompass: true }), 'top-left');
      // map.addControl(new MultiTouch());

      if(locations !== null) {

        locations.map(l => {
          const centerMarker = mapMarker();
          centerMarker.setLngLat([l.lng, l.lat])
          .setPopup(
            new window.mapboxgl
            .Popup({ offsetLeft: -12, offsetTop: -40 })
            .setHTML(`<div className='popupInfoWrapper'>
              <h3 style="margin: 0; font-size: 14px;">${l.name}</h3>
              <p style="margin: 0; font-size: 14px; line-height: 20px;">${l.state + ', ' + l.city + ', ' + l.address}</p>
              <div className='popupInfoLink'>
                <a href='${window.location.origin}/winery/${l.slug}'>Go to winery details</a>
                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9343 4.42611L10.9344 4.42598L10.93 4.421L7.85417 0.960488C7.61809 0.680384 7.16225 0.658232 6.89246 0.899736C6.62296 1.14098 6.59335 1.59706 6.8456 1.86285L8.91987 4.19513H1.5769C1.20306 4.19513 0.9 4.49821 0.9 4.87205C0.9 5.24591 1.20306 5.54897 1.5769 5.54897H8.91987L6.84559 7.88126C6.59217 8.14831 6.62993 8.60362 6.89809 8.84366L6.96299 8.77116L6.89809 8.84367C7.16779 9.08507 7.61803 9.0638 7.85417 8.78362L10.93 5.3231L10.9304 5.32346L10.9365 5.31498C11.046 5.16251 11.1023 5.00917 11.0999 4.85483C11.0975 4.70035 11.0364 4.55762 10.9343 4.42611Z" fill="#78264F" stroke="#78264F" stroke-width="0.2"/>
                </svg>
              </div>
            </div>`)
          )
          .addTo(map);
        })
      }

      return () => map.remove();
    }
  }, [locations]);

  return !isMapsLibLoaded ? (
    <div className={css.root} />
  ) : (
    <div className={css.root}>
			<div className={css.mapRoot} ref={mapContainer} />
    </div>
  )
}

export default MboxMap
